<!-- ======================= Page Body ========================== -->
<div class="container page-top-gap">
    <div class="row">
        <div class="col-lg-12">
            <div class="card page-body">

                <!-- ================ Desired Card Selection ================ -->
                <div class="layout-container desired-card">
                    <div class="layout-col width-250">
                        <div class="card-size m-r-20 m-b-20"><img src="{{selcetedCard?.SelectionImage}}"
                                alt="Platinum Credit Card"> </div>
                    </div>
                    <div class="layout-col white-space-wrap font-bold">
                        <p>{{selcetedCard?.Name}}</p>
                    </div>
                </div>
                <hr>
                <!-- ================ /Desired Card Selection ================ -->

                <!-- ================ Form ================ -->

                <div class="m-t-30">
                    <form [formGroup]="desiredCreditLimitFormGroup">
                        <div class="outer-blue-box">
                            <div class="m-auto flex-single-column p-t-50">

                                <!-- ========= Form Row ========= -->
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <div class="form-group">
                                          <div class="layout-container">
                                            <div class="layout-col p-r-40 v-align-top white-space-wrap">
                                              <label class="control-label" i18n="@@PleaseEnterCreditLimitQuestion">PleaseEnterCreditLimitQuestion</label>
                                            </div>
                                            <div class="layout-col full-width">
                                              <input formControlName="DesiredCreditLimitTxBx"
                                                     (blur)="desiredCreditLimitTxBx_Blur($event)" type="text"
                                                     class="form-control" />
                                              <div *ngIf="(submitted || desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.touched || desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.dirty) && desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.errors"
                                                   class="msg-error">
                                                <div *ngIf="desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.errors.required" i18n="@@PleaseEnterCreditLimitError">PleaseEnterCreditLimitError</div>
                                                <div *ngIf="desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.errors.moreThanMax" i18n="@@CreditLimitShouldNotGreater">CreditLimitShouldNotGreater</div>
                                                <div *ngIf="desiredCreditLimitFormGroup.controls.DesiredCreditLimitTxBx.errors.invalidcurrency" i18n="@@CreditLimitContainsNonNumerics">CreditLimitContainsNonNumerics</div>
                                              </div>
                                            </div>
                                            <div class="layout-col v-align-top usd-top-gap" *ngIf="this.selcetedCard.CardCurrency === 'USD'">
                                              <span class="label-1 p-l-20">USD</span>
                                            </div>
                                            <div class="layout-col v-align-top usd-top-gap" *ngIf="this.selcetedCard.CardCurrency === 'SAR'">
                                                <span class="label-1 p-l-20">SAR</span>
                                            </div>
                                          </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ========= /Form Row ========= -->

                                <!-- ========= Form Row ========= -->
                                <div class="row">
                                    <div class="col-md-12 col-sm-12">
                                        <div class="form-group">
                                            <div class="layout-container">
                                                <div class="layout-col p-r-40">
                                                    <label class="control-label"></label>
                                                </div>
                                                <div class="layout-col full-width">
                                                    <button [disabled]="this.desiredCreditLimitFormGroup.invalid"
                                                        (click)="calcuateBtnClick()" class="btn btn-primary"
                                                        i18n="@@Calculate">Calculate</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- ========= /Form Row ========= -->

                            </div>
                            <hr />
                            <div class="layout-col text-footnote" i18n="@@DesiredCreditLimitTermsAndConditions">DesiredCreditLimitTermsAndConditions</div>
                        </div>
                    </form>
                </div>

                <!-- ================ /Form ================ -->

            </div>
        </div>
    </div>
</div>
<!-- ======================= /Page Body ========================== -->
